<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="15" height="15" stroke="currentColor" />
    <rect x="2.5" y="12.5" width="5" height="5" stroke="currentColor" />
    <path d="M7 13L14 6M14 6V12M14 6H8" stroke="currentColor" />
  </svg>
</template>
